const AUTH_CAPTCHA_CAPABILITY_HEADER = "X-Auth-Captcha-Capable";

const withAuthCaptchaCapability = (headers = {}) => ({
  ...headers,
  [AUTH_CAPTCHA_CAPABILITY_HEADER]: "1",
});

const authCaptchaPayload = (payload, captchaVerifyParam) => {
  if (!captchaVerifyParam) {
    return payload;
  }

  return {
    ...payload,
    captcha_verify_param: captchaVerifyParam,
  };
};

const getAuthErrorCode = (err) =>
  err?.error || err?.data?.error || err?.response?.data?.error || null;

const isSilentAuthCaptchaError = (err) => getAuthErrorCode(err) === "captcha_required";

const getAuthCaptchaCallbackResult = (err) => {
  if (!err) {
    return { captchaResult: true, bizResult: true };
  }
  if (getAuthErrorCode(err) === "captcha_invalid") {
    return { captchaResult: false, bizResult: false };
  }
  return { captchaResult: true, bizResult: false };
};

module.exports = {
  AUTH_CAPTCHA_CAPABILITY_HEADER,
  authCaptchaPayload,
  getAuthCaptchaCallbackResult,
  getAuthErrorCode,
  isSilentAuthCaptchaError,
  withAuthCaptchaCapability,
};
